<template>
  <v-container fluid style="margin: 0px">
    <v-card
      elevation="0"
      style="
        margin-top: 0px !important;
        margin-bottom: -30px !important;
        overflow: hidden;
        background-color: transparent;
      "
      class="px-5 py-1"
    >
      <v-row
        class="custom-gray-background fill-width d-flex"
        v-if="mostrarFiltro"
      >
        <v-col cols="12" sm="12" md="12">
          <!-- Botão para adicionar filtros -->
          <v-btn @click="adicionarFiltro" color="#4682B4" small>
            Adicionar Filtro
            <v-icon style="margin-left: 8px">mdi-plus</v-icon>
          </v-btn>
        </v-col>

        <!-- Renderizar dinamicamente os filtros adicionados -->
        <template v-for="(filtro, index) in filtros">
          <v-col :key="index" cols="12" sm="6" md="3">
            <v-select
              v-model="filtro.tipo"
              :items="tiposDisponiveis(index)"
              label="Selecionar Filtro"
              dense
              class="compact-field"
              solo-inverted
              @change="onFiltroChange(index)"
            ></v-select>
          </v-col>

          <v-col
            :key="'data-inicial-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="3"
            v-if="isDateField(filtro.tipo)"
          >
            <v-menu
              v-model="filtro.dataInicialAberto"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ on }">
                <v-text-field
                  v-model="filtro.dataInicialFormatada"
                  label="Data Inicial"
                  dense
                  solo-inverted
                  readonly
                  class="compact-field"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="filtro.dataInicial"
                @input="
                  filtro.dataInicialAberto = false;
                  filtro.dataInicialFormatada = formatDate(filtro.dataInicial);
                  // Garante que a data está no formato correto
                  if (filtro.dataInicial && !filtro.dataInicial.includes('/')) {
                    // Já está no formato ISO (YYYY-MM-DD)
                  }
                "
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            :key="'data-final-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="3"
            v-if="isDateField(filtro.tipo)"
          >
            <v-menu
              v-model="filtro.dataFinalAberto"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ on }">
                <v-text-field
                  v-model="filtro.dataFinalFormatada"
                  label="Data Final"
                  dense
                  solo-inverted
                  readonly
                  class="compact-field"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="filtro.dataFinal"
                @input="
                  filtro.dataFinalAberto = false;
                  filtro.dataFinalFormatada = formatDate(filtro.dataFinal);
                  // Garante que a data está no formato correto
                  if (filtro.dataFinal && !filtro.dataFinal.includes('/')) {
                    // Já está no formato ISO (YYYY-MM-DD)
                  }
                "
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- Campo: Produto -->
          <v-col
            :key="'produto-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="6"
            v-if="filtro.tipo === 'Produto'"
          >
            <v-select
              v-model="filtro.valor"
              :items="tipos_funerarios"
              multiple
              dense
              solo-inverted
              class="compact-field"
              label="Produto"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="filtro.valor.length <= 2">
                  {{ item
                  }}<span v-if="index === 0 && filtro.valor.length === 2"
                    >, &nbsp;</span
                  >
                </span>
                <span v-else-if="index < 2">
                  {{ item }}<span v-if="index === 0">, </span>
                </span>
                <span v-else-if="index === 2"> ... </span>
              </template>
            </v-select>
          </v-col>

          <!-- Campo: Empresa -->
          <v-col
            :key="'empresa-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="6"
            v-if="filtro.tipo === 'Empresa'"
          >
            <v-select
              small
              v-model="filtro.valor"
              :items="empresas"
              class="compact-field"
              label="Selecione a Empresa"
              dense
              solo-inverted
              multiple
            ></v-select>
          </v-col>

          <!-- Campo: Tipo -->
          <v-col
            :key="'tipo-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="6"
            v-if="filtro.tipo === 'Tipo'"
          >
            <v-select
              v-model="filtro.valor"
              class="compact-field"
              :items="tipos"
              label="Selecione o Tipo"
              dense
              solo-inverted
            ></v-select>
          </v-col>

          <!-- Campo: Tipo -->
          <v-col
            :key="'tipo-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="6"
            v-if="filtro.tipo === 'Situação'"
          >
            <v-select
              v-model="filtro.valor"
              class="compact-field"
              :items="opcoes"
              label="Selecione o Tipo"
              dense
              solo-inverted
            ></v-select>
          </v-col>

          <!-- Campo: Documentos Filtrados (somente ROLE_LIST_ADMIN) -->
          <v-col
            :key="'doc-filtrados-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="6"
            v-if="filtro.tipo === 'Documentos Filtrados'"
          >
            <v-checkbox
              v-model="filtro.valor"
              label="Ativar documentos filtrados"
              dense
              hide-details
              class="mt-0"
            ></v-checkbox>
          </v-col>

          <!-- Campo: Origem do Documento -->
          <v-col
            :key="'origem-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="6"
            v-if="filtro.tipo === 'Origem do Documento'"
          >
            <v-select
              v-model="filtro.valor"
              :items="origensDocumento"
              item-text="text"
              item-value="value"
              multiple
              dense
              solo-inverted
              class="compact-field"
              label="Origem do Documento"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="filtro.valor.length <= 2">
                  {{ item.text
                  }}<span v-if="index === 0 && filtro.valor.length === 2"
                    >, &nbsp;</span
                  >
                </span>
                <span v-else-if="index < 2">
                  {{ item.text }}<span v-if="index === 0">, </span>
                </span>
                <span v-else-if="index === 2"> ... </span>
              </template>
            </v-select>
          </v-col>

          <!-- Botão Remover -->
          <v-col
            :key="'remover-' + index"
            class="custom-col-spacing"
            cols="12"
            sm="6"
            md="3"
          >
            <v-btn
              @click="removerFiltro(index)"
              color="#FF5733"
              small
              fab
              outlined
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </template>
      </v-row>
      <br />

      <v-divider></v-divider>

      <!-- Botões de ação -->
      <v-card-actions class="justify-end">
        <v-btn
          @click="alternarVisibilidade"
          color="#4682B4"
          small
          class="mr-2"
          style="font-size: 14px !important; font-weight: bold"
        >
          {{ mostrarFiltro ? "Ocultar Filtro" : "Mostrar Filtro" }}
          <v-icon style="margin-left: 8px" dark>{{
            mostrarFiltro ? "mdi-eye-off" : "mdi-eye"
          }}</v-icon>
        </v-btn>

        <v-btn
          @click="limparFiltro"
          v-if="mostrarFiltro"
          color="#4682B4"
          small
          outlined
          class="mr-2"
          style="font-size: 14px !important; font-weight: bold"
        >
          Limpar
        </v-btn>
        <v-btn
          @click="filtrar"
          v-if="mostrarFiltro"
          color="#4682B4"
          small
          style="font-size: 14px !important; font-weight: bold"
        >
          Filtrar
          <v-icon style="margin-left: 8px" dark>mdi-filter</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      mostrarFiltro: true,
      filtros: [],
      tipos: [
        "Todos",
        "Planos",
        "Planos Florais",
        "Jazigo",
        "Cremação",
        "Funerária",
        "Serviços Administrativos e Cemiteriais",
      ],
      opcoes: ["Todas", "Pago", "Em Aberto", "Cancelado"],
      tipos_funerarios: [
        "Todos",
        "CONCESSÃO DE COLUMBÁRIO",
        "CONCESSÃO DE JAZIGOS",
        "CONCESSÃO DE OSSÁRIO",
        "CREMAÇÃO",
        "CREMAÇÃO COM CERIMÔNIA",
        "CREMAÇÃO SEM CERIMÔNIA",
        "COMPLETO",
        "FAMILIA",
        "INTEGRAL",
        "PROTEÇÃO",
        "JARDIM DAS MEMÓRIAS",
        "TOTAL",
        "PF - AMPARO",
        "PV - AMIGO",
        "PV - BRONZE",
        "PV - CREMAÇÃO COM CERIMÔNIA",
        "PV - DIAMANTE",
        "PV - EMPRESARIAL",
        "PV - EMPRESARIAL - EMPRESA",
        "PV - ESPECIAL",
        "PV - ESMERALDA",
        "PV - ESSENCIAL",
        "PV - IDEAL",
        "PV - MAIOR",
        "PV - MAIS",
        "PV - MASTER GOLD",
        "PV - MELHOR",
        "PV - PLANO PJ",
        "PV - PLUS",
        "PV - POLICIA MILITAR",
        "PV - PRATA",
        "PV - PREVIDA",
        "PV - PREVIPARQ DO AGRESTE",
        "PV - RUBI",
        "PV - SÃO MATHEUS",
        "URNAS CINERARIAS",
        "VENDA DE COLUMBÁRIO",
        "VENDA DE JAZIGOS - IMEDIATO",
        "VENDA DE JAZIGOS - PREVENTIVO",
        "VENDA DE JAZIGOS - TRANSITÓRIO",
      ],
      empresas: [
        "Todas",
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA SÃO MIGUEL",
      ],
      tiposDeFiltrosBase: [
        "Data Vencimento",
        "Data Pagamento",
        "Data de Emissão",
        "Data de Cancelamento",
        "Data de Adesão",
        "Produto",
        "Situação",
        "Empresa",
        "Tipo",
        "Origem do Documento",
      ],
      user: null,
      origensDocumento: [
        { text: "Contrato", value: 2 },
        { text: "Venda", value: 1 },
        { text: "Acordo", value: 3 },
      ],
    };
  },

  computed: {
    podeVerDocumentosFiltrados() {
      const roles = this.user?.roles;
      return Array.isArray(roles) && roles.includes("ROLE_LIST_ADMIN");
    },

    tiposDeFiltros() {
      const tipos = [...this.tiposDeFiltrosBase];
      if (this.podeVerDocumentosFiltrados) {
        tipos.push("Documentos Filtrados");
      }
      return tipos;
    },
  },

  created() {
    const userRaw = sessionStorage.getItem("user");
    if (userRaw) {
      try {
        this.user = JSON.parse(userRaw);
      } catch (e) {
        this.user = null;
      }
    }
  },

  methods: {
    tiposDisponiveis(index) {
      const tiposSelecionados = this.filtros
        .filter((_, i) => i !== index)
        .map((f) => f.tipo)
        .filter(Boolean); // ignora nulos

      return this.tiposDeFiltros.filter(
        (tipo) => !tiposSelecionados.includes(tipo)
      );
    },
    adicionarFiltro() {
      this.filtros.push({
        tipo: null,
        valor: null,
        dataInicial: null,
        dataFinal: null,
        dataInicialFormatada: null,
        dataFinalFormatada: null,
        dataInicialAberto: false,
        dataFinalAberto: false,
        teste: null,
      });
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    removerFiltro(index) {
      this.filtros.splice(index, 1);
    },

    onFiltroChange(index) {
      const filtro = this.filtros[index];
      filtro.valor =
        filtro.tipo === "Documentos Filtrados" ? false : null;
      // Resetar datas apenas se for campo de data
      if (this.isDateField(filtro.tipo)) {
        filtro.dataInicial = null;
        filtro.dataFinal = null;
        filtro.dataInicialFormatada = null;
        filtro.dataFinalFormatada = null;
      }
    },

    alternarVisibilidade() {
      this.mostrarFiltro = !this.mostrarFiltro;
    },

    limparFiltro() {
      this.filtros = [];
    },

    filtrar() {
      const origemFiltro = this.filtros.find(
        (f) => f.tipo === "Origem do Documento"
      );
      // Mapeia os valores de origem para números (já vem como número do item-value)
      const origemValores = origemFiltro?.valor || null;

      // Busca o filtro de Data de Adesão
      const adesaoFiltro = this.filtros.find((f) => f.tipo === "Data de Adesão");
      
      // Se a data formatada existir mas a data inicial não, converte
      if (adesaoFiltro) {
        if (adesaoFiltro.dataInicialFormatada && !adesaoFiltro.dataInicial) {
          adesaoFiltro.dataInicial = this.parseDate(adesaoFiltro.dataInicialFormatada);
        }
        if (adesaoFiltro.dataFinalFormatada && !adesaoFiltro.dataFinal) {
          adesaoFiltro.dataFinal = this.parseDate(adesaoFiltro.dataFinalFormatada);
        }
      }
      
      const filterValues = {
        dataCancelamentoInicial:
          this.filtros.find((f) => f.tipo === "Data de Cancelamento")
            ?.dataInicial || null,
        dataCancelamentoFinal:
          this.filtros.find((f) => f.tipo === "Data de Cancelamento")
            ?.dataFinal || null,
        dataPagamentoInicial:
          this.filtros.find((f) => f.tipo === "Data Pagamento")?.dataInicial ||
          null,
        dataPagamentoFinal:
          this.filtros.find((f) => f.tipo === "Data Pagamento")?.dataFinal ||
          null,
        dataEmissaoInicial:
          this.filtros.find((f) => f.tipo === "Data de Emissão")?.dataInicial ||
          null,
        dataEmissaoFinal:
          this.filtros.find((f) => f.tipo === "Data de Emissão")?.dataFinal ||
          null,
        dataVencimentoInicial:
          this.filtros.find((f) => f.tipo === "Data Vencimento")?.dataInicial ||
          null,
        dataVencimentoFinal:
          this.filtros.find((f) => f.tipo === "Data Vencimento")?.dataFinal ||
          null,
        dataAdesaoInicial: adesaoFiltro?.dataInicial || null,
        dataAdesaoFinal: adesaoFiltro?.dataFinal || null,
        selectedProduto:
          this.filtros.find((f) => f.tipo === "Produto")?.valor || null,
        selectedCompany:
          this.filtros.find((f) => f.tipo === "Empresa")?.valor || null,
        selectedType:
          this.filtros.find((f) => f.tipo === "Tipo")?.valor || null,
        selectedOpcao:
          this.filtros.find((f) => f.tipo === "Situação")?.valor || null,
        origemDocumento: origemValores, // Array de números [1, 2, 3]
        listDocBlack:
          this.filtros.find((f) => f.tipo === "Documentos Filtrados")?.valor ===
          true,
      };

      this.$emit("filtrar", filterValues);
    },

    isDateField(tipo) {
      return [
        "Data Vencimento",
        "Data Pagamento",
        "Data de Emissão",
        "Data de Cancelamento",
        "Data de Adesão",
      ].includes(tipo);
    },

    getListDocBlackAtivo() {
      if (!this.podeVerDocumentosFiltrados) {
        return false;
      }
      const filtro = this.filtros.find((f) => f.tipo === "Documentos Filtrados");
      return filtro?.valor === true;
    },
  },
};
</script>
<style>
.compact-field {
  font-size: 14px; /* Reduz o tamanho da fonte */
  height: 36px; /* Reduz a altura total do campo */
  padding: 0 8px; /* Reduz o padding interno */
}

.custom-col-spacing {
  margin-bottom: 8px; /* Reduz a margem inferior */
  padding-bottom: 0; /* Remove o padding inferior */
}
</style>
